// Owner: interaction-kit (wave 1), design-system (wave 2). Extension point: top bar items (the
// notification bell, presence avatars, an editor's ✦ button). Host: shell-nav.
// Contribution files: `src/features/**/topbar.ts`, default export `defineTopbarItem(…)` or an array.
import type { ComponentType } from 'react';
import { createExtensionRegistry, hasMember, hasShape } from './registry';

export type TopbarItemProps = { pathname: string; compact: boolean };

export type TopbarItemDefinition = {
  /** Unique, dotted: `inbox.bell`, `collab.presence`. */
  id: string;
  placement: 'start' | 'end';
  order?: number;
  /** Shown on these paths only (default: everywhere the top bar is). */
  routes?: (pathname: string) => boolean;
  Component: ComponentType<TopbarItemProps>;
};

export function defineTopbarItem(def: TopbarItemDefinition): TopbarItemDefinition {
  return def;
}

export const topbarItems = createExtensionRegistry<TopbarItemDefinition>({
  point: 'topbar',
  glob: 'features/**/topbar.ts',
  host: 'shell-nav',
  modules: import.meta.glob('../features/**/topbar.ts', { eager: true }),
  key: (i) => i.id,
  check: (v): v is TopbarItemDefinition => hasShape(v, ['id', 'placement']) && hasMember(v, 'Component'),
});

export function topbarItemsFor(pathname: string, placement: 'start' | 'end'): TopbarItemDefinition[] {
  return topbarItems
    .list()
    .filter((i) => i.placement === placement && (i.routes?.(pathname) ?? true))
    .sort((a, b) => (a.order ?? 1000) - (b.order ?? 1000));
}
